import React, { useState, createContext, useEffect } from "react";
import MoreProjectsDetails from "./assets/MoreProjectsDetails";
export const MoreProjectsContext = createContext();
export const MoreProjectsProvider = (props) => {
  const [projects, setProjects] = useState(MoreProjectsDetails);
  const [latestFirstSort, setLatestFirstSort] = useState(true);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  useEffect(() => {
    let arr = [];
    MoreProjectsDetails.forEach((p) => {
      arr = [...new Set(arr.concat(...p.tags))]
        .map((t) => t.toLowerCase())
        .sort();
    });
    setTags([...new Set(arr)]);
  }, []);
  return (
    <MoreProjectsContext.Provider
      value={{
        projects,
        setProjects,
        latestFirstSort,
        setLatestFirstSort,
        tags,
        setTags,
        selectedTags,
        setSelectedTags,
      }}
    >
      {props.children}
    </MoreProjectsContext.Provider>
  );
};
